/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { radioStateModelSchema } from "../radioStateModelSchema.ts";
import { updateRadioStatusModelSchema } from "../updateRadioStatusModelSchema.ts";
import { z } from "zod";

/**
 * @description Статус обновлен
 */
export const patchApiPurewaveSettingRadio200Schema = z.lazy(() => radioStateModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const patchApiPurewaveSettingRadio400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiPurewaveSettingRadio401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiPurewaveSettingRadio403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiPurewaveSettingRadio500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const patchApiPurewaveSettingRadioMutationRequestSchema = z.lazy(() => updateRadioStatusModelSchema).describe("Тело запроса")

export const patchApiPurewaveSettingRadioMutationResponseSchema = z.lazy(() => patchApiPurewaveSettingRadio200Schema)